import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[emailMask]'
})

export class EmailMaskDirective {
  private regex: RegExp = new RegExp(/[^A-Za-z0-9.@\-_]/g);

  private specialKeys = ['Backspace', 'Tab', 'End', 'Home'];

  constructor(private el: ElementRef) { }

  @HostListener('keypress', ['$event'])
  onkeypress(event: KeyboardEvent) {
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }

    let current: string = this.el.nativeElement.value;

    let next: string = current.concat(event.key);
    if (next && String(next).match(this.regex)) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  blockPaste(event: KeyboardEvent) {
    let current: string = this.el.nativeElement.value;
    const next: string = current.concat(event['clipboardData'].getData('Text'));

    if (next && String(next).match(this.regex)) {
      event.preventDefault();
    }
  }

  @HostListener('dragover', ['$event'])
  onDragOver(event: any) {
    event.dataTransfer.dropEffect = 'none';
    return event.preventDefault();
  }
}
